import { InlineLoading } from '@zeal/web-ui';
import React from 'react';

const LoadingState = () => {
	return (
		<InlineLoading className="flex items-center !justify-start gap-1 text-gray-500" />
	);
};

export default LoadingState;
